import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import MapControls from "../../components/map-controls/map-controls";
import { MapLeftPanel } from "../../shared/map-left-panel/map-left-panel";
import MasterPlanModificationPortal from "../../components/features/master-plan-modification-portal/master-plan-modification-portal";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import {
  MapSection,
  resetAttributesModalState,
  resetImportModalState,
  setConvertedGeometry,
  setSection,
} from "../../services/reducers/map";
import { initializeMap } from "../../services/actions/map";
import styles from "./master-plan-portal-page.module.scss";
import { MapWrapper } from "../../shared/map-wrapper/map-wrapper";
import { useAppSelector } from "../../hooks/useAppSelector";
import { FormationTypeNames } from "../../services/reducers/master-plan-modification";
import EditAttributesModalGlobal from "../../shared/edit-attributes-modal-global/edit-attributes-modal-global";

export const MasterPlanPortalPage = () => {
  const [leftPanelOpened, setLeftPanelOpened] = useState<boolean>(true);
  const dispatch = useAppDispatch();
  const [panelWidth, setPanelWidth] = useState<number>(0);
  const { selectedFormationType } = useAppSelector(
    (state) => state.masterPlanModification,
  );
  const { drawingToolsIsActive, attributesModal } = useAppSelector(
    (state) => state.map,
  );

  useEffect(() => {
    dispatch(setSection(MapSection.masterPlan));
    dispatch(initializeMap({ section: MapSection.masterPlan, mode: "2d" }));
    return () => {
      dispatch(initializeMap({ section: MapSection.none, mode: "2d" }));
      dispatch(setConvertedGeometry(null));
      dispatch(resetImportModalState());
      dispatch(resetAttributesModalState());
    };
  }, []);

  const { t } = useTranslation();
  return (
    <div className={styles.masterPlanPage}>
      <MapLeftPanel
        isExtendedWidth={true}
        onWidthChange={setPanelWidth}
        leftPanelOpened={leftPanelOpened}
        closeLeftPanel={setLeftPanelOpened}
      >
        <MasterPlanModificationPortal />
      </MapLeftPanel>
      <MapWrapper
        leftPanelOpened={leftPanelOpened}
        panelWidth={panelWidth}
        containerId={`${MapSection.masterPlan}MapContainer`}
      >
        {drawingToolsIsActive ? (
          <div className={styles.help}>
            {selectedFormationType === FormationTypeNames.Create
              ? t("master-plan-portal-page.createPlotBoundaries")
              : t("master-plan-portal-page.editPlotBoundaries")}
          </div>
        ) : null}
      </MapWrapper>
      <MapControls />
      {attributesModal.visible && <EditAttributesModalGlobal />}
    </div>
  );
};
